import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { NoSsr } from '@mui/material'
import { getYear } from 'date-fns'
import { RouterPage } from 'lib/navigation/consts'
import { marketingLinks } from 'lib/consts/externalLinks'
import * as $ from './Footer.styled'

export interface FooterProps {
  className?: string
}

export const Footer: FC<FooterProps> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <$.Root className={className}>
      <$.Links>
        <$.Text>
          Settle © <NoSsr>{getYear(new Date())}</NoSsr>
        </$.Text>
        <$.Link href={RouterPage.termsOfService}>{t('termsOfService')}</$.Link>
        <$.Link href={marketingLinks.privacyPolicy}>{t('privacy')}</$.Link>
      </$.Links>
    </$.Root>
  )
}
